<p-breadcrumb  [model]="menuItems | async" styleClass="border-none surface-100 p-0 mb-1 text-xxs"></p-breadcrumb>